
import { rachelMediaArray } from './rachelMedia'
import { monicaReviewerProfile, rossReviewerProfile, joeyReviewerProfile } from './rachelReviewers'
import { joeyBio, monicaBio, rossBio, rachelBio } from './rachelBios'
import { rachelDatingProfileHinge, rachelDatingProfileBumble, rachelDatingProfileTinder } from './rachelDatingProfiles'

export const rachelUser = {
  _id: 'rachelUserId',
  email: 'rachel@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...monicaReviewerProfile },
    { ...rossReviewerProfile },
    { ...joeyReviewerProfile }
  ],
  media: [ ...rachelMediaArray ],
  bio: { ...rachelBio },
  datingProfiles: [
    { ...rachelDatingProfileHinge },
    { ...rachelDatingProfileBumble },
    { ...rachelDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const monicaUser = {
  _id: 'monicaUserId',
  email: 'monica@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...monicaBio },
  datingProfiles: [],
  reviewerProfile: { ...monicaReviewerProfile },
}

export const rossUser = {
  _id: 'rossUserId',
  email: 'ross@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...rossBio },
  datingProfiles: [],
  reviewerProfile: { ...rossReviewerProfile },
}

export const joeyUser = {
  _id: 'joeyUserId',
  email: 'joey@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...joeyBio },
  datingProfiles: [],
  reviewerProfile: { ...joeyReviewerProfile },
}
